export default __webpack_public_path__ + "static/media/SAND.36cbd20e.png";